const caseTerms = {
//Basic terminology
	wordCase: "Case",
	id: "Case ID",
	caseNotifications: "Case Notifications",
	notifications: "Notifications",
	noNotifications: "You currently have no notifications for this case.",
	caseStatus: "Case Status",
	caseOverview: "Case Overview",
	dateOpened: "Date Opened",
	dateSubmitted: "Date Submitted",
	dateReceived: "Date Received By Administration",
	dateResolved: "Date Resolved",

	caseDocs: "Case Documents",

	activeNotification: "You have a notification for this case!",
	receiveNotification: "Receive Notification",
	receiveConfirmation: "Are you sure you want to receive this notification?",
	receiveDisclaimer: "Once you receive this notification, if the administration requires any additional documents from you, this will 'start the clock' on any deadline.",
	unreceivedNotifications: "Unreceived Notifications",
	receivedNotifications: "Received Notifications",
	remainingDays: "You have 10 calendar days to receive a notification, at which time the system will receive it for you.",
	notificationDisclaimer: "The system will automatically receive notifications for you after 10 days.",
	receivingNotification: "The system will retrieve your notification as soon as possible. Please check back later.",
	receiving: "Receiving",
	daysAgo: "Received DAYS days ago",

//Editing the case

	editCase: "Edit Case",
	uploadNewDoc: "Upload New Document",
	addAvailableDoc: "Add Previously Uploaded Document",
	submitNewDoc: "Submit Addition",


}

export default caseTerms;
